import { render, staticRenderFns } from "./CreateTeam.vue?vue&type=template&id=39040c4d&scoped=true"
import script from "./CreateTeam.vue?vue&type=script&lang=js"
export * from "./CreateTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39040c4d",
  null
  
)

export default component.exports